// action - account reducer
export const LOGIN = 'LOGIN';
export const MFA_REQUIRED = 'MFA_REQUIRED';
export const MFA_CHALLENGE = 'MFA_CHALLENGE';
export const FETCH_MASKED_MFA_METHODS = 'FETCH_MASKED_MFA_METHODS';
export const FETCH_USER_INFO = 'FETCH_USER_INFO';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';

// action - isp reducer
export const ISP_INFO = 'ISP_INFO';
